<script>
  import { afterUpdate, createEventDispatcher } from "svelte"
  const dispatch = createEventDispatcher()
  import ApplicationState from "../../../../Stores/applicationStates"
  import notify from "../../../../Script/notify"
  import alias, { updateAlias } from "../../Document_Control/Stores/alias"
  import { push } from "svelte-spa-router"
  import LoadingScreen from "../../../Publish/SinglePublish/Components/loadingScreen.svelte"
  import { loadTooltip } from "../../../../Script/loadTooltip"
  import { postRequest } from "../../../../Script/apiMethods"
  import RevokeConfirm from "../../../../Shared/revokeConfirm.svelte"

  export let json

  /**
   * @type {Boolean} - whether to disable next button or not
   */
  let apiCallBtnDisable = false

  /**
   * @type {Boolean} - whether to disable OTP model or not
   */
  let revokeOTPModal = false

  /**
   * @description Function for revoke the published document
   * @param {Object} json - selected list details
   */
  const handleRevocation = async (e) => {
    revokeOTPModal = false
    apiCallBtnDisable = true

    const revokeDetails = e.detail

    try {
      const CONFIG = {
        headers: {
          "x-access-token": $ApplicationState.token,
        },
      }

      const { signature } = await postRequest(
        `/api/swagger/v2/misc/proxy-sign`,
        {
          msg: json.id,
          otp: revokeDetails.code,
        },
        CONFIG
      )

      await postRequest(
        `/api/swagger/v2/documents/${json.id}/revoke`,
        {
          signature,
          revokeReason: revokeDetails.revokeReason,
          hideRevokedDoc: revokeDetails.hideRevokedDoc,
        },
        CONFIG
      )

      notify.success("The document has been successfully revoked")
      dispatch("reload")
    } catch (error) {
      const info = "PAGE: Document List\nEVENT: Error occurred while revoking document."
      notify.danger(error, info)
    } finally {
      apiCallBtnDisable = false
    }
  }

  afterUpdate(() => {
    loadTooltip()
    window.addEventListener("resize", loadTooltip)
  })
</script>

<div class="mx-auto mt-3 flex h-full w-full items-center justify-between gap-6 border-l-8 hover:shadow-md dark:border-y-2 dark:border-r-2 dark:border-y-transparent dark:border-r-transparent {json.notRevoked && (json.dataHash || json.fileHash) && json.datePublished ? ' border-green-500 dark:hover:border-green-500' : json.datePublished ? 'border-red-500 dark:hover:border-red-500' : 'border-yellow-500 dark:hover:border-yellow-500'} gap-3 rounded-r-md bg-white px-6 py-3 dark:bg-lightgray">
  <div class="space-y-1.5 truncate text-gray-800 dark:text-gray-200">
    <!-- <p class= text-xs font-semibold text-gray-800 sm:text-base">{json.id}</p> -->
    <a href={json.url} target="_blank" class="select-none text-xs font-semibold hover:text-blue-500 sm:text-base">{json.options.title ? json.options.title : "Untitled document"} {json.recName ? `for ${json.recName}` : ""}</a>
    <!-- <p class="select-none text-xs font-semibold text-gray-800 sm:text-base">Un titled document for {json.recName}</p> -->
    <div class="flex items-center gap-3">
      {#if json.datePublished}
        <p title={json.datePublished ? "Published On" : "PENDING"} class="font select-none truncate text-xs font-normal text-gray-200 sm:text-base">
          <i class="fa-solid fa-calendar-days" />
          &nbsp;&nbsp;{new Date(json.datePublished).toString().slice(0, 24)}
        </p>
      {/if}
    </div>
  </div>
  <div class="flex select-none justify-end">
    <a
      name="tooltip"
      id="Analytics"
      tooltip-position="top"
      href="#/analytics/documents/single?id={json.id}"
      disabled={!json.datePublished}
      on:click={() => {
        $alias.proposedURL = json.url
        updateAlias($alias)
      }}
      class=" flex cursor-pointer items-center justify-center rounded-full px-3 py-2 text-sm font-medium text-[#0ea5e9] hover:bg-[#0b84ba] hover:text-white active:bg-[#0b84ba] disabled:cursor-not-allowed disabled:bg-none disabled:text-gray-500 disabled:hover:bg-transparent disabled:active:bg-transparent sm:px-5"
    >
      <i class="fa-solid fa-chart-mixed" />
      <span class="hidden lg:block">&nbsp;&nbsp;Analytics</span>
    </a>

    <button
      name="tooltip"
      id="Secure Access"
      tooltip-position="top"
      disabled={!json.datePublished || json.version == 1}
      on:click={() => {
        $alias.proposedURL = json.url
        updateAlias($alias)
        push(`/documents/single/secure_access?id=${json.id}`)
      }}
      class="flex cursor-pointer items-center justify-center rounded-full px-3 text-sm font-medium text-[#09f6e7] hover:bg-[#06aca2] hover:text-white active:bg-[#06aca2] disabled:cursor-not-allowed disabled:text-gray-500 disabled:hover:bg-transparent disabled:active:bg-transparent sm:px-5"
    >
      <i class="fa-solid fa-file-shield" />

      <span class="hidden lg:block">&nbsp;&nbsp;Secure&nbsp;Access</span>
    </button>
    <button name="tooltip" id={json.notRevoked || json.version != 1 ? "Revoke" : "Revoked"} tooltip-position="top" disabled={!json.notRevoked || !json.datePublished || json.version == 1} on:click={() => (revokeOTPModal = true)} title={json.notRevoked && json.version != 1 ? "Not Revoked" : json.dateRevoked ? `Revoked On ${new Date(json.dateRevoked).toString().slice(0, 24)}` : json.version == 1 ? "Old document can't be revoke" : "Revoked date NA"} class="flex cursor-pointer items-center justify-center gap-2 rounded-full px-3 text-sm font-medium text-red-500 hover:bg-red-500 hover:text-white active:text-red-400 disabled:cursor-not-allowed disabled:text-gray-500 disabled:hover:bg-transparent disabled:active:bg-transparent sm:px-5">
      <i class="fa-solid fa-file-excel" />
      <span class="hidden lg:block">{json.notRevoked || json.version == 1 ? "Revoke" : "Revoked"}</span>
    </button>
  </div>
</div>

{#if revokeOTPModal && !apiCallBtnDisable}
  <RevokeConfirm
    on:submit={handleRevocation}
    on:close={() => {
      revokeOTPModal = false
    }}
  />
{/if}

{#if apiCallBtnDisable}
  <LoadingScreen msg="Revoking Document" />
{/if}

<style>
  ::-webkit-scrollbar-thumb {
    background: #f7f7f7;
    border-radius: 20px;
  }
  ::-webkit-scrollbar {
    height: 4px;
  }
</style>
